<app-jveg-template-list *ngIf="ShowJVEG$ | async" (SelectedJVEGTemplateId)="PushValuesToForm.next($event)"></app-jveg-template-list>
<!-- <div class="list-wrapper" [style.width]="(ShowJVEG$ | async) ? 'auto' : '100%'"> -->
<!-- <div class="list-wrapper" [style.width]="'100%'"> -->
<div class="list-wrapper" style="width: 100%">
    <!-- <mat-card style="padding-top: 0; padding-bottom: 0;margin-bottom: -20px;">
        <app-arl-template-type-chip-autocomplete [FormControl]="Form.controls.TemplateTypeName" [SelectedOptions]="SelectedOptions"></app-arl-template-type-chip-autocomplete>
    </mat-card> -->
    <app-detail-list-template [Editing]="true" [Inline]="!(ShowJVEG$ | async)" [Data]="ListTemplateData$ | async"></app-detail-list-template>
</div>
